export class ArgumentException extends Error {
  constructor(
    private _name: string,
    message?: string,
  ) {
    super(`${_name}`);
  }
}
